import getForm from '../form_wizard/elements/getForm';
import getFieldValue from '../form_wizard/elements/getFieldValue';
import { track } from './track';

export function trackFormWizardEvent(el, { category, action }) {
  const label = action.replace(/\.|-/g, '_');
  const form = getForm(el);
  const formVersion = getFieldValue(form, 'leadform');
  const data = {
    target: label,
    dataAttributes: {
      leadformVersion: formVersion,
      leadformAction: action,
    },
    category: category,
    label: label,
  };
  return track('lead-form', data);
}
